import {ServerNotificationProps} from '../ServerNotification';
import {INotificationProps} from '@src/@interfaces/components/Notifications/INotificationProps';
import app from '@src/helpers/app';
import InfoNotification from '../../InfoNotification';
import {toDate} from '@views/orders/fields/logs/messages';
import makeUrl from '@src/components/Notifications/server-notifications/makeUrl';
import getDashboardEndpoint from '@src/components/Notifications/server-notifications/Order/getDashboardEndpoint';

export default class StatusLifetimeExpired extends InfoNotification<
        ServerNotificationProps<'App\\Notifications\\Order\\StatusLifetimeExpired'> &
        INotificationProps
> {
    protected getWrapperTagProps(): any {
        const payload = this.props.notification.data;
        const namesResolver = app('names-resolver').clientRoutes;

        return {
            ...super.getWrapperTagProps(),
            to: makeUrl({
                uriItems: [
                    getDashboardEndpoint('manager-order-page', payload.orderId),
                    {
                        route: namesResolver.getShowRouteName('Orders'),
                        params: {id: String(payload.orderId)},
                    }
                ],
            }),
        };
    }

    protected getDescriptionReplacements() {
        return {
            ...this.props.notification.data,
            expiredAt: toDate(this.props.notification.data.expiredAt),
        };
    }
}
